import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppRouter from "./AppRouter";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

const redirectUri =
	process.env.NODE_ENV === "production"
		? "https://muktibd.com"
		: "http://localhost:3000";

const cognitoAuthConfig = {
	authority:
		"https://cognito-idp.us-east-1.amazonaws.com/us-east-1_qQ0n6G838",
	client_id: "5kg0lkt0g05v69n84bqhvv6m3j",
	redirect_uri: redirectUri,
	response_type: "code",
	scope: "email openid phone",
	automaticSilentRenew: true, // Automatically refresh token
	loadUserInfo: true,
	userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<AuthProvider {...cognitoAuthConfig}>
			<App />
		</AuthProvider>
	</React.StrictMode>
);
//<App /> --> replacing App with AppRouter
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
